import React from "react";
import { Box, Flex, Grid, Image, Select, Text, useColorMode } from "theme-ui";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import Arrow from "../assets/images/Icon/select.svg";
import { useSearchParams, useLocation } from "react-router-dom";
import theme from "../../theme";
interface props {
    TotalCount?: number,
    onPageChange: (page: number) => void,
    onPerPageChange: (value: string) => void,
    TotalLength?: number,
    perPageCount?: number,
    CurrentPage: number,
}
const TablePagination: React.FC<props> = ({
    TotalCount,
    onPageChange,
    onPerPageChange,
    TotalLength = 0,
    perPageCount = 15,
    CurrentPage = 1
}) => {
    const [searchParams] = useSearchParams({
        currentPage: "1",
        limit: "15",
    });

    const limit = Number(perPageCount) || 15;

    const location = useLocation();
    const urlPage = location.search.includes('currentPage=') ? searchParams.get('currentPage') : null;
    const currentPage = urlPage ? Number(urlPage) : Number(CurrentPage || 1);
    const [colorMode] = useColorMode();
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";

    const startResult = TotalLength === 0 ? 0 : ((currentPage - 1) * limit) + 1;
    const endResult = currentPage * limit > TotalLength ? TotalLength : currentPage * limit;
    const totalPages = Math.max(1, Math.ceil(TotalLength / limit));

    return (
        <Flex mt={5} sx={{ justifyContent: "center", alignItems: "center", backgroundColor: modalHeader }}>
            <Grid columns={[1, 1, 1, 3]} className="text-center">

                <Text as={"span"} variant="Poppins16Normal25lh" className="pagination-summary" sx={{ border: `1px solid ${theme.colors?.muted}`, backgroundColor: modalHeader, color: colorMode === "light" ? "secondary" : "#fff" }}>
                    Displaying Result {' '} {`${startResult}-${endResult} of ${TotalLength}`}
                </Text>
                <Box className="d-flex text-center align-content-center justify-content-center">
                    <Text variant="Poppins16Normal25lh" sx={{ fontWeight: 400, color: colorMode === "light" ? "secondary" : "#fff" }} mt={2} className="mr-1">Rows per page:</Text>
                    <Select
                        sx={{ color: titleHeader, border: colorMode === "light" ? "1px solid secondary" : "1px solid #8F9195" }}
                        className="ms-4"
                        value={limit}
                        arrow={
                            <Image src={Arrow} alt="" sx={{ ml: -22, alignSelf: 'center', pointerEvents: 'none' }} />
                        }
                        onChange={(e) => onPerPageChange(e.target.value)}>

                        {[15, 25, 50, 100]?.map((item, index) => {
                            return (
                                <option
                                    key={index}
                                    value={item}
                                    style={{ color: titleHeader, fontWeight: 500 }}>
                                    {item}
                                </option>
                            )
                        })}
                    </Select>
                </Box>
                <ResponsivePagination
                    nextClassName="pagination"
                    pageItemClassName="pagination"
                    current={currentPage}
                    total={totalPages}
                    maxWidth={32}
                    onPageChange={onPageChange}
                />
            </Grid>
        </Flex>
    );
};

export default TablePagination;
